import React from 'react'
import styled from 'styled-components'
import { Text } from 'rebass'
import { BigNumber } from 'bignumber.js'

// Drink Fruit Bread
const foodNames3 = [
  ['Orange Juice', 'Sake', 'Milk Tea', 'Earl Grey'],
  ['Mangosteen', 'Kiwi', 'Mango', 'Watermelon'],
  ['Butter Toast', 'Burger', 'Avocado Sandwich', 'Croissant']
]
// Drink Fruit Bread Sushi
const foodNames4 = [
  ['Orange Juice', 'Sake', 'Milk Tea', 'Earl Grey'],
  ['Mangosteen', 'Kiwi', 'Mango', 'Watermelon'],
  ['Butter Toast', 'Burger', 'Avocado Sandwich', 'Croissant'],
  ['Salmon Nigiri', 'Ebi Tempura Nigiri', 'Onigiri', 'Ikura Sushi']
]
// Drink Bread Sashimi Sushi Fruit
const foodNames5 = [
  ['Orange Juice', 'Sake', 'Milk Tea', 'Earl Grey'],
  ['Butter Toast', 'Burger', 'Avocado Sandwich', 'Croissant'],
  ['Salmon Sashimi', 'Hokki Sashimi', 'Hotate Sashimi', 'Ebi Sashim'],
  ['Salmon Nigiri', 'Ebi Tempura Nigiri', 'Onigiri', 'Ikura Sushi'],
  ['Mangosteen', 'Kiwi', 'Mango', 'Watermelon']
]
// Bread Drink Sashimi Fruit Dessert Sushi
const foodNames6 = [
  ['Butter Toast', 'Burger', 'Avocado Sandwich', 'Croissant'],
  ['Orange Juice', 'Sake', 'Milk Tea', 'Earl Grey'],
  ['Salmon Sashimi', 'Hokki Sashimi', 'Hotate Sashimi', 'Ebi Sashim'],
  ['Mangosteen', 'Kiwi', 'Mango', 'Watermelon'],
  ['Chocolate Cake', 'Durian mille crepe cake', 'Strawberry Pudding', 'Blueberry Pancake'],
  ['Salmon Nigiri', 'Ebi Tempura Nigiri', 'Onigiri', 'Ikura Sushi']
]
interface foodMapProps {
  [key: string]: string[][]
}
const foodMap: foodMapProps = {
  '3': foodNames3,
  '4': foodNames4,
  '5': foodNames5,
  '6': foodNames6
}

const Wrapper = styled.div<{bg?: string}>`
  background: ${({ bg, theme }) => bg ? bg : theme.bsBg7};
  border-radius: 10px;
  color: ${({ theme }) => theme.bsText8};
  height: 82px;
  margin: 0 16px;
  padding: 6px 12px;
  overflow-y: auto;
`

export default function FoodsList({items, bg}: {items: string[], bg?: string}) {
  let foodsText = ''
  try {
    const len: number = items.length
    const foodNames = foodMap[len] ? foodMap[len] : foodMap[6]
    foodsText = items.map((d) => {
      return new BigNumber(d).div(100000).integerValue(BigNumber.ROUND_FLOOR).toNumber()
    }).map((d, i) => {
      return foodNames[i][d]
    }).join(', ')
  } catch(e) {
    console.log(e)
  }

  return (
    foodsText ? (
      <Wrapper bg={bg}>
        <Text fontSize={14}>
          { foodsText }
        </Text>
      </Wrapper>
    ) : null
  )
}
